import React from 'react'

interface IProps {
    title: string
    description?: string
}

const TestModeToast: React.FC<IProps> = ({ title, description }) => (
    <div className={'test-mode-toast'}>
        <strong>{title}</strong>
        {description && <span>{description}</span>}
    </div>
)

export default TestModeToast
